import { useTextos } from "../context/useTextos";
import { logout } from "../../store/auth";

// So o dado estrutural (chave/icone/feature) fica aqui -- o rotulo vem do
// i18next em tempo de render via t(`checklist.nav_${key}`), no mesmo padrao
// usado no restante do painel (ver frontend/src/i18n/locales/{pt,en,es}.json).
const NAV_ITEMS = [
  { key: "dashboard", i18nKey: "nav_dashboard", icon: "🏠" },
  { key: "checklists", i18nKey: "nav_checklists", icon: "📋" },
  { key: "relatorios", i18nKey: "nav_relatorios", icon: "📊" },
  { key: "clientes", i18nKey: "nav_clientes", icon: "👤", feature: "clientesVeiculos" },
  // AUD-C: o icone acompanha o segmento -- ver ICONE_POR_SEGMENTO abaixo.
  { key: "veiculos", i18nKey: "nav_veiculos", icon: "🚗", feature: "clientesVeiculos" },
  { key: "config", i18nKey: "nav_config", icon: "⚙️" },
];

// AUD-C: so o item "veiculos" troca de icone; os outros sao neutros.
const ICONE_POR_SEGMENTO = { moto: { veiculos: "\ud83c\udfcd\ufe0f" } };

// AUD-U1e (21/10/2026) -- o rodape do checklist para quem so tem o checklist.
//
// Mesma leitura e mesma comparacao do AUD-U1d (PrivateRoute.js): atob no
// payload do JWT, caixa e espacos normalizados, e so o valor exato
// "checklist" muda alguma coisa.
//
// try/catch amplo devolvendo FALSE: na duvida, o rodape fica como esta hoje.
// Um token quebrado nao tem o direito de trocar a navegacao de ninguem.
function soChecklist() {
  try {
    const token = (sessionStorage.getItem("access_token") || localStorage.getItem("access_token"));
    if (!token) return false;
    const payload = JSON.parse(atob(token.split(".")[1]));
    return String(payload.papel || "").trim().toLowerCase() === "checklist";
  } catch { return false; }
}

export default function Sidebar({ active, onNavigate, workshopName, logoUrl, features, mobileOpen, onCloseMobile }) {
  const { t, segmento } = useTextos();
  const icones = ICONE_POR_SEGMENTO[segmento] || {};
  function handleNavigate(key) {
    onNavigate(key);
    if (onCloseMobile) onCloseMobile();
  }

  return (
    <>
      {mobileOpen && <div className="sidebar__overlay" onClick={onCloseMobile} />}
      <nav className={`sidebar ${mobileOpen ? "sidebar--mobile-open" : ""}`}>
        <div className="sidebar__brand">
          {logoUrl ? (
            <img src={logoUrl} alt={t("checklist.logo_alt")} className="sidebar__logo" />
          ) : (
            <div className="sidebar__logo sidebar__logo--placeholder">
              {workshopName?.charAt(0)?.toUpperCase() || "O"}
            </div>
          )}
          <span className="sidebar__name">{workshopName}</span>
          <button type="button" className="sidebar__close-mobile" onClick={onCloseMobile} aria-label={t("checklist.fechar_menu")}>
            ×
          </button>
        </div>
        <ul className="sidebar__nav">
          {NAV_ITEMS.filter((item) => !item.feature || features?.[item.feature]).map((item) => (
            <li key={item.key}>
              <button
                type="button"
                className={`sidebar__nav-item ${active === item.key ? "is-active" : ""}`}
                onClick={() => handleNavigate(item.key)}
              >
                <span className="sidebar__nav-icon" aria-hidden="true">
                  {icones[item.key] || item.icon}
                </span>
                {t(`checklist.${item.i18nKey}`)}
              </button>
            </li>
          ))}
        </ul>
        <div className="sidebar__footer">
          {soChecklist() ? (
            // Para o funcionario, "Voltar ao Painel" nao volta a painel
            // nenhum: o AUD-U1d o traria direto para ca de novo. O que faz
            // sentido para ele e encerrar a sessao. A chave "sidebar.sair"
            // ja existe traduzida em pt, en e es -- nao criei texto novo.
            <button type="button" className="sidebar__back-link" onClick={logout}>
              <span className="sidebar__nav-icon" aria-hidden="true">🚪</span>
              {t("sidebar.sair")}
            </button>
          ) : (
            <a href="/" className="sidebar__back-link">
              <span className="sidebar__nav-icon" aria-hidden="true">←</span>
              {t("checklist.voltar_ao_painel")}
            </a>
          )}
        </div>
      </nav>
    </>
  );
}
